import type { IContentBase } from "@/types/content";
import type { MaybeRef } from "vue";

export type GetContentListParams = {
  __limit?: number;
  taskType?: string;
  order?: "asc" | "desc";
};

export function useContentListRequest(params?: MaybeRef<GetContentListParams>) {
  const query = useInfiniteQuery({
    queryKey: ["content", params],
    async queryFn({ pageParam }: { pageParam?: string | null }) {
      const { data } = await useGetRequest<{
        items: IContentBase[];
        lastEvaluatedKey?: string;
      }>("/content", {
        params: {
          nextQuery: pageParam,
          __limit: unref(params)?.__limit,
          taskType: unref(params)?.taskType,
          order: unref(params)?.order,
        },
      });
      if (data.items) {
        data.items = data.items.map(c => ({
          ...c,
          resultData: maybeParseJson(c.resultData),
        }));
      }
      return data;
    },
    staleTime: 2 * MINUTE,
    initialPageParam: null,
    getNextPageParam: lastPage => lastPage.lastEvaluatedKey || null,
    select: data => data.pages.filter(page => page.items).flatMap(page => page.items),
  });
  return query;
}
